type SelectSubscription = {
    value: string;
    subscribe: (fn: (value: string) => void) => void;
    unsubscribe: () => void;
};

export function metricChartSelectorSubscription(selectId: string): SelectSubscription {
    const selectEl = document.getElementById(selectId) as HTMLSelectElement | null;

    if (!selectEl) {
        throw new Error(`Select element with id "${selectId}" not found`);
    }

    let currentValue = selectEl.value;
    let callback: ((value: string) => void) | null = null;

    const handler = () => {
        currentValue = selectEl.value;
        if (callback) callback(currentValue);
    };

    return {
        value: currentValue,

        subscribe(fn) {
            callback = fn;
            selectEl.addEventListener("change", handler);
            // Notify immediately on subscription
            fn(currentValue);
        },

        unsubscribe() {
            selectEl.removeEventListener("change", handler);
            callback = null;
        }
    };
}


type Subscriber<T> = (value: T) => void;

export function createChartFilterStore<T>(initialValue: T) {
    let value = initialValue;
    const subscribers: Subscriber<T>[] = [];

    return {
        subscribe(fn: Subscriber<T>) {
            subscribers.push(fn);
            fn(value);
            return () => {
                const index = subscribers.indexOf(fn);
                if (index !== -1) subscribers.splice(index, 1);
            };
        },
        set(newValue: T) {
            value = newValue;
            subscribers.forEach(fn => fn(value));
        },
        update(updater: (prev: T) => T) {
            value = updater(value);
            subscribers.forEach(fn => fn(value));
        },
        get value() {
            return value;
        }
    };
}